import { defineStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  borderRadius: '8px',
  padding: '12px',
};

export const tooltipTheme = defineStyleConfig({ baseStyle });
